import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '../Context/ThemeContext';
import { AuthProvider } from '../Context/AuthContext';
import ScrollToTop from '../Components/ScrollToTop';
import Home from '../Pages/Home';
import VehicleDetail from '../Pages/VehicleDetail';
import Vehicles from '../Pages/Vehicles';
import Services from '../Pages/Services';
import About from '../Pages/About';
import Contact from '../Pages/Contact';
import Quote from '../Pages/Quote';
import KVKK from '../Pages/KVKK';
import SellCar from '../Pages/SellCar';

const AppRouter = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/araclar" element={<Vehicles />} />
            <Route path="/hizmetler" element={<Services />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/teklif-al" element={<Quote />} />
            <Route path="/detail/:type/:id" element={<VehicleDetail />} />
            <Route path="/aracini-sat" element={<SellCar />} />
            <Route path="/kvkk" element={<KVKK />} />
            
            {/* Default redirect for unknown routes */}
            <Route path="*" element={<Home />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default AppRouter;
